import React from "react";
import FileExplorerTheme from "App/components/Tables/SortableTreeCommon/Theme";
import DepotTransferTableRow from "./DepotTransferTableRow";
import styles from "./DepotTransferTable.module.scss";
import { SortableTreeWithoutDndContext as SortableTree } from "react-sortable-tree";
const externalNodeType = "item";

const DepotTransferTable = ({
  treeData,
  onTreeChange,
  getNodeKey,
  canNodeHaveChildren,
  updateNode,
  deleteNode,
  restoreName,
  selectRow,
  moveFocusToNextRow,
  costNominals,
  taxRates,
  enabled,
}) => {
  return (
    <div className={styles.tableContainer}>
      <div className={styles.header}>
        <div className={`${styles.headerCell} ${styles.headerRowPad}`}>
          Name
        </div>
        <div className={`${styles.headerCell} ${styles.headerProduct}`}>
          Product
        </div>
      </div>
      <SortableTree
        theme={FileExplorerTheme}
        dndType={externalNodeType}
        treeData={treeData}
        onChange={onTreeChange}
        getNodeKey={getNodeKey}
        canNodeHaveChildren={canNodeHaveChildren}
        generateNodeProps={({ node, path }) => {
          return DepotTransferTableRow({
            node,
            path,
            updateNode,
            deleteNode,
            restoreName,
            selectRow,
            moveFocusToNextRow,
            costNominals,
            taxRates,
            enabled,
          });
        }}
      />
    </div>
  );
};

export default DepotTransferTable;
